<template>
  <div class="container faq-block">
    <div class="row">
      <div class="col-12">
        <div class="accordion">
          <h2 class="accordion__h2">Frequently asked questions</h2>
          <div data-aos="fade-down" v-for="(accordion, index) in accordions" :key="accordion.title">
            <div class="accordion__container">
              <button
                @click="accordion.showAccordion = !accordion.showAccordion"
                :class="{ active: accordion.showAccordion }"
                class="p-0 accordion__header col-12"
                :aria-labelledby="`accordion-${index}`"
              >
                <span
                  :class="{ active: accordion.showAccordion }"
                  class="my-1 accordion__title col-12 d-flex justify-content-between align-items-center text-start"
                >
                  {{ accordion.title }}
                </span>
              </button>
              <div
                :aria-hidden="!accordion.showAccordion"
                :aria-expanded="accordion.showAccordion"
                v-show="accordion.showAccordion"
                class="accordion__text"
                :id="`accordion-${index}`"
                v-html="accordion.text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";

const accordions = ref([
  {
    title: "How do I activate my SIM?",
    text: ` <p>Your SIM will be shipped to you. When you receive your SIM you need to log into the <a href=" https://portal.grapefroot.co.uk/">portal</a> and add the last 4 digits of your SIM serial number. When you switch your phone back on everything should be working. If not please see our FAQ about locked phones.
            </p>
            <p>If you are still having issues then please contact our support.</p>
            <p>If you are performing a PAC switch (transferring your existing number) we'll transfer your number within one working day (Monday-Friday, 9am-5pm, excluding bank holidays). If we receive your code after 5pm, the switch will be within two working days.
            </p>
            <p>How do I get a PAC code?</p>
            <p>If you don't have one, request PAC Code <a href="https://text-to-switch.co.uk/" target='_blank'>here!</a> </p> 

              `,
    showAccordion: false,
  },
  {
    title: "My phone was on another network and needs unlocking. How do I do that?",
    text: ` <p>If you have moved over from another network you may need to unlock your phone.
            https://unlockpedia.net/ is a great resource where you can find your handset and
            follow their instructions for the best way to unlock your device.</p>
            <p>There may be a small cost from a local or major retailer to unlock your device.
            This can be in the region of £10-£15.</p>`,
    showAccordion: false,
  },
  {
    title: "My bill says grapefroot mobile but my sim card says O2 or Vodafone",
    text: ` <p><p>While your contract is through grapefroot mobile we give you the option of
            selecting from different networks so you can find the best plan for you.</p>`,
    showAccordion: false,
  },
  {
    title: "How do I add or remove a bolt on?",
    text: `
            <p>Log in to your account and visit SIMs and plans. From here you can view the bolt ons available to
            you and upgrade from there or remove a bolt on.</p>`,
    showAccordion: false,
  },
  {
    title: "I can't connect to a network",
    text: `
            <p>If you are having trouble connecting to a network then please try the following:</p>
            <ul>
                <li>
                    Turn your phone off and on again.
                </li>
                <li>
                    Make Sure you have turned your mobile data on in your settings
                </li>
                <li>
                    Reset your network settings
                </li>
            </ul>
          `,
    showAccordion: false,
  },
  {
    title: "What can affect my signal?",
    text: `
          <p>Your phone signal will be stronger outside. Some buildings can affect your phone signal, as can the weather and your location (e.g. remote).</p>`,
    showAccordion: false,
  },
  {
    title: "Can I use my phone abroad?",
    text: `<p>Yes. If you are on an O2 plan then in the EU you can roam like you are back in the UK with no charges. For other networks and areas you may be subject to charges.</p>`,
    showAccordion: false,
  },
]);
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.faq-block {
  padding: 0 2rem;
  filter: drop-shadow(var(--box-shadow));
}

.faqsection-que-block {
  padding: 1.5rem 1.5rem 5rem !important;
}

h2 {
  font-size: 1.6em;
}

.accordion {
  margin-bottom: 5em;
  &__h2 {
    color: var(--peach);
  }

  ul {
    color: var(--primary);
  }

  &__header {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;
    border-bottom: solid 1px rgb(223, 223, 223);
    margin: 0 0 5px;
    padding: 10px 10px 10px;
  }
  &__text {
    color: var(--primary);
    border: none;
    padding: 10px 0 0px;
    animation: appear 0.25s;
    border-radius: 10px;
    @media only screen and (min-width: 992px) {
      border-radius: 10px;
    }
    & > p,
    a {
      color: var(--primary);
    }
  }
  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: bold;
    font-size: 1.1em;
    &:after {
      content: "+";
      font-size: 2em;
      float: right;
      position: relative;
      transition: 1s;
      font-weight: 100;
      margin-left: 1em;
    }
    &.active:after {
      content: "-";
      font-size: 2em;
    }
  }
}
</style>
